import React, { FC } from "react";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const ArrowUpRightFromSquare: FC<Omit<FontAwesomeIconProps, "icon">> = (
  props
) => <FontAwesomeIcon icon={faArrowUpRightFromSquare} {...props} />;
